import { CognitoUser, AuthenticationDetails, CognitoUserSession } from "amazon-cognito-identity-js";
import { createUserPool } from "./userPool";

export interface SignInResult {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}

export function signIn(email: string, password: string): Promise<SignInResult> {
  // In-memory storage for both the pool and the user, so the tokens and the
  // email are never written to this site's localStorage.
  const { pool, storage } = createUserPool();
  const user = new CognitoUser({ Username: email, Pool: pool, Storage: storage });
  const authDetails = new AuthenticationDetails({ Username: email, Password: password });

  // Drop whatever the library cached, on every outcome. signOut() without a
  // callback only clears client data; it does not revoke the refresh token
  // we are handing to the app.
  const forget = () => {
    user.signOut();
    storage.clear();
  };

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess(session: CognitoUserSession) {
        const result = {
          accessToken: session.getAccessToken().getJwtToken(),
          idToken: session.getIdToken().getJwtToken(),
          refreshToken: session.getRefreshToken().getToken(),
        };
        forget();
        resolve(result);
      },
      onFailure(err) {
        forget();
        reject(err);
      },
      // This site has no set-new-password screen. Without this callback the
      // library throws and the form stays on "Signing in..." forever.
      newPasswordRequired() {
        forget();
        reject(new Error("You need to set a new password. Contact support@kast-dev.net."));
      },
    });
  });
}
